import { flagContext } from "@redotech/openfeature-contracts/context";
import { FeatureFlagContextKind } from "./keys";

export interface TeamFlagContext {
  readonly teamId: string;
  readonly teamCreatedAt: Date;
}

export const teamContext = flagContext<TeamFlagContext>({
  kind: FeatureFlagContextKind.TEAM,
  targetingKey: ({ teamId }) => teamId,
  attributes: ({ teamCreatedAt }) => ({ teamCreatedAt }),
});

/** Not targeted at anything: a system-wide value. */
export const systemContext = flagContext<Record<string, never>>({
  kind: FeatureFlagContextKind.SYSTEM,
  targetingKey: () => "system",
});

/** A MongoDB collection, by name. */
export const collectionContext = flagContext<{ readonly collection: string }>({
  kind: FeatureFlagContextKind.COLLECTION,
  targetingKey: ({ collection }) => collection,
});

/** A claim submission method (usps, ups, fedex, ...). */
export const claimSubmissionMethodContext = flagContext<{
  readonly method: string;
}>({
  kind: FeatureFlagContextKind.CLAIM_SUBMISSION_METHOD,
  targetingKey: ({ method }) => method,
});

export const temporalNamespaceContext = flagContext<{
  readonly namespace: string;
}>({
  kind: FeatureFlagContextKind.TEMPORAL_NAMESPACE,
  targetingKey: ({ namespace }) => namespace,
});

/** A deployed service (DD_SERVICE), with its cost-owner cloud. */
export const serviceContext = flagContext<{
  readonly service: string;
  readonly cloud?: string;
}>({
  kind: FeatureFlagContextKind.SERVICE,
  targetingKey: ({ service }) => service,
  attributes: ({ cloud }): Record<string, string> => (cloud ? { cloud } : {}),
});

/** A merchant user, by email. The user kind is billed per key. */
export const userEmailContext = flagContext<{ readonly email: string }>({
  kind: FeatureFlagContextKind.USER,
  targetingKey: ({ email }) => email,
});

/** A shopper, by Redo customer id; email is only for segments. */
export const customerContext = flagContext<{
  readonly customerId: string;
  readonly email?: string;
}>({
  kind: FeatureFlagContextKind.USER,
  targetingKey: ({ customerId }) => customerId,
  attributes: ({ email }): Record<string, string> =>
    email ? { name: email, email } : {},
});
